export default {
  baseUrl: 'http://localhost:3001/api',
  notificatorUrl: 'https://localhost:8000',
};
